import { memo } from 'react'
import { useSelector } from 'react-redux'
import AccountInfo from './AccountInfo'

function Account() {
  const userInfoState = useSelector<any, any>((state) => state.currentUser.getIn(['userInfo']))
  const userInfo = userInfoState.toJS()

  return <AccountInfo user={userInfo} />
}

export default memo(Account)
